<y42-single-select
  label="App theme"
  [formCtrl]="formCtrl"
  [optionValue]="'value'"
  [trackBy]="trackByValueField"
  [options]="appThemeOptions"
>
  <ng-template [y42SelectOption]="selectOptionType" let-theme>
    <y42-icon [icon]="theme.icon" class="mr-space"></y42-icon>
    <span>{{ theme.name }}</span>
  </ng-template>
</y42-single-select>
